export const emitFilter = async (data, args, {events, type}) => {
    const callbacks = events[type] || [];
    const sortedCallbacks = Array.from(callbacks.values()).sort((a, b) => a.priority - b.priority);
    try {
        for (const entry of sortedCallbacks) {
            data = await Promise.resolve(entry.callback(data, args));
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
    return data;
}